<template lang="pug">
  .component-vehicle-hardware-action-buttons
    .dropdown-buttons
      button.button.small.alert(@click="remove") Remove
      modal-reveal(sizing="small", ref="modalUpdateHardware")
        button.button.small.warning(slot="trigger") Edit
        h2 Edit Vehicle hardware VH{{item.id}}
        .row
          .column
            label Manager
              select(v-model="manager")
                option(v-for="(manager, index) in managers") {{index}}
          .column
            label Serial
              input(type="text" v-model="item.serial")
        .row
          .column
            label Extra
            array-edit(:values="item.extra")
            .text-right
              .fa.fa-download.fa-2x.text-right(title="Click to copy the configuration", @click="exportConfiguration")
            input#clipboard(type="hidden", :value="JSON.stringify(item.extra)")

            button.button(@click="editHardware") Edit Hardware
</template>

<script>
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "../../../../maggieHelper";
  import ModalReveal from "../../foundation/ModalReveal";
  import ConfigurationItem from "../../../backoffice/ConfigurationItem";
  import ArrayEdit from "../ArrayEdit";

  export default {
    name: "VehicleHardwareActionButtons",
    components: {ArrayEdit, ConfigurationItem, ModalReveal},
    data() {

      return {
        clipboard: null,
        managers: null,
        manager: null,
      }
    },
    created() {
      var extra = this.item.extra.length === 0 || this.item.length !== undefined ? {} : this.item.extra
      this.item.extra = extra
      this.$set(this.item.extra, extra)
      KeplerBackofficeSdk.vehicleHardware.list.managers((data) => {
        this.managers = data
        switch (this.item.manager) {
          case this.managers.manual:
            this.manager = 'manual'
            break;
          case this.managers.convadis:
            this.manager = 'convadis'
            break

        }
      })
    },
    methods: {
      exportConfiguration() {

        let testingCodeToCopy = document.querySelector('#clipboard')
        testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
        testingCodeToCopy.select()

        try {
          document.execCommand('copy');
          MaggieHelper.notification('Copied', 'Configuration copied successfully')
        } catch (err) {
          alert('Oops, unable to copy');
        }

        /* unselect the range */
        testingCodeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      },
      remove() {
        this.$confirm('Are you sure?', `Do you really want to remove VH${this.item.id}`, () => {
          KeplerBackofficeSdk.vehicleHardware.select(this.item.id).remove((data) => {
            MaggieHelper.notification('remove-esit', 'Vehicle hardware deleted')
            this.$emit('update')
          })
        })
      },
      editHardware() {
        this.item.manager = this.managers[this.manager]

        KeplerBackofficeSdk.vehicleHardware.select(this.item.id).edit(this.item, () => {
          MaggieHelper.notification('update-esit', 'Vehicle hardware updated')

          this.$refs.modalUpdateHardware.close()
          this.$emit('update')


        })

      },
      importConfiguration() {
        this.item.extra = JSON.parse(this.clipboard)
      }
    },
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VehicleHardwareActionButtons.vue?0aa1ba0e